import { useMultiLoading } from 'hooks/useMultiLoading'
import CIMSCheckbox from '../../../../../CIMSCheckbox'
import { CheckboxCIMSBasicField as Props } from './types'

const CheckboxCIMSBasicField: React.FC<Props> = ({
  type,
  label,
  hidden,
  help,
  onChange,
  disabled,
  ...rest
}) => {
  const { loading, addLoading, removeLoading } = useMultiLoading()
  return (
    <CIMSCheckbox
      loading={onChange ? loading(onChange.loadingKey) : false}
      disabled={disabled}
      onChange={
        onChange
          ? async (e) => {
              addLoading(onChange.loadingKey)
              await onChange.callback(e)
              removeLoading(onChange.loadingKey)
            }
          : undefined
      }
      {...rest}
    />
  )
}

export default CheckboxCIMSBasicField
